import he from "./he.json";
import en from "./en.json";

import usFlag from "./../../assets/images/flags/us.jpg"
import hebrew from "./../../assets/images/flags/israel.png"

const languages = {
    en: {
        label: "English",
        flag: usFlag,
    },
    he: {
        label: "Hebrew",
        flag: hebrew
    }
}

const extractLang = (): string => {
    let lang = localStorage.getItem('lang');
    return lang && typeof lang === "string" ? lang : 'en';
}

const lng = extractLang();
export { he, en, lng, languages }
